import React, {useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, DateInput, ReferenceInput, required, Title} from 'react-admin';
import {downloadFile, ReportForm} from '../../components';
import env from '../../env';
import moment from "moment";

const TongHopDatHang = (props) => {
    const [state, setState] = useState({
        fromDate: new Date(),
        toDate: new Date(),
        kiotId: '',
    });

    const getReportUrl = () => {
        return `${env.kiotUrl}/reports/kiot/tongHopDatHang?fromDate=${moment(state.fromDate).format('YYYY-MM-DD')}&toDate=${moment(state.toDate).format('YYYY-MM-DD')}&kiotId=${state.kiotId}`;
    };

    const excelReport = () => {
        downloadFile(getReportUrl(), 'tong_hop_dat_hang.xlsx')
    };

    const validate = (values) => {
        const errors = {};
        setState(values);
        return errors;
    };

    return (
        <Card>
            <Title title="resources.tong-hop-dat-hang.name"/>
            <CardContent>
                <ReportForm params={state}
                            validate={validate}
                            excelReport={excelReport}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.fromDate" source="fromDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.toDate" source="toDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ReferenceInput source="kiotId"
                                            validate={required()}
                                            {...props}
                                            reference="kiotConfigs"
                                            allowEmpty
                                            sort={{field: 'name', order: 'ASC'}}
                                            label="resources.kiotConfigs.name"
                                            perPage={999}>
                                <AutocompleteInput optionText="name"/>
                            </ReferenceInput>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default TongHopDatHang

